import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const HowWeWorkPage = lazy(() => import('../pages/how-we-work/page'));
const WorkflowSystemArchitecturePage = lazy(() => import('../pages/services/workflow-system-architecture/page'));
const IntakeAutomationPage = lazy(() => import('../pages/services/intake-automation/page'));
const CrmAutomationPage = lazy(() => import('../pages/services/crm-automation/page'));
const ConciergeAiPage = lazy(() => import('../pages/services/concierge-ai/page'));
const EstimatePage = lazy(() => import('../pages/estimate/page'));
const GetStartedPage = lazy(() => import('../pages/get-started/page'));
const ThankYouPage = lazy(() => import('../pages/thank-you/page'));
const ClientBillingPortalPage = lazy(() => import('../pages/client-billing-portal/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsOfServicePage = lazy(() => import('../pages/terms-of-service/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services/how-we-work',
    element: <HowWeWorkPage />,
  },
  {
    path: '/services/workflow-system-architecture',
    element: <WorkflowSystemArchitecturePage />,
  },
  {
    path: '/services/intake-automation',
    element: <IntakeAutomationPage />,
  },
  {
    path: '/services/crm-automation',
    element: <CrmAutomationPage />,
  },
  {
    path: '/services/concierge-ai',
    element: <ConciergeAiPage />,
  },
  {
    path: '/estimate',
    element: <EstimatePage />,
  },
  {
    path: '/get-started',
    element: <GetStartedPage />,
  },
  {
    path: '/thank-you',
    element: <ThankYouPage />,
  },
  {
    path: '/client-billing-portal',
    element: <ClientBillingPortalPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfServicePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;